export default __webpack_public_path__ + "static/media/winterface_hero.abcac215.png";